// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.hero-content{
    display:bloc;
    flex-direction: column;
    width:100vw;
    height:100vh;
    
    position:relative;

}


.hero-content svg{
    position: relative;
        left: 1px;
        bottom:120px;
    
   
   
    
}

.overlay{
       
        text-align: center;
        display:flex;
        justify-content: center;
        flex-direction:column;
        justify-items: center;
        align-items: center;
        opacity: 0;
        transform: translateX(60%);
       
           

}



.overlay.left{
       position: absolute;
        top: 40%;
        left: 10%;
        transform: translateX(-60%);
}

.overlay.right{
    position:absolute;
    top:40%;
    right:15%;
}


.overlay.animate.right{
    animation: slideIn 1s forwards;
}


.overlay.animate.left{
    animation:slideIn 1s forwards;
}



.overlay button{
    color:#fff;
    background-color: #FF3C4E;
    width:131.52px;
    height:42px;
    border-radius:25px;
    text-decoration: underline;
    position: relative;
    overflow: hidden;
    cursor: pointer;
        
    z-index:1
    

}




.overlay button::after{
/* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #F2C713;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);
    
    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}

.overlay button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}
.overlay .header{
    color:#FF3C4E;
    font-family: 'EB Garamond', serif;
    font-size: 36px;
    font-weight: 900;
    
}

@keyframes slideIn{
    to {
            opacity: 1;
           
            transform: translateX(0);
            
        }
}



.overlay .description{
    color:#222222;
    font-family: 'Nunito',sans-serif;
    font-size: 18px;
    width:500px;
    text-align: center;
   
    text-justify: auto;
    display: flex;
    align-content: center;
    justify-content: center;
    
}
.content{
    width:100vw;
    height:100vh;
    display:flex;
    flex-direction: row;
   
    align-items:center;
    /* margin-top:80px; */
    flex:1 1;
    
}

@media screen and (max-width:768px){
    .hero-content {
            display: bloc;
            flex-direction: column;
            width: 100vw;
            height: 100vh;
    
            position: relative;
    
        }

    .overlay {
    
            text-align: center;
            display: flex;
            justify-content: center;
            flex-direction: column;
            justify-items: center;
            align-items: center;
            opacity: 0;
            transform: translateX(60%);
    
    
    
    }
        .content {
            width: 100vw;
            height: 80%;
            display: flex;
            flex-direction: row;
    
            align-items: center;
            /* margin-top:80px; */
            flex: 1 1;
    
        }
    .overlay.left {
            position: absolute;
            top: 65%;
            left:0px;
            transform: translateX(-60%);
            width: 90%;
            
        }
    
   .overlay.right {
            position: absolute;
            top: 65%;
            right:0px;
            width:90%;
            
        }
    .overlay .header{
        font-size:15px;
        margin-bottom: 5px;
    }
.overlay .description{
    color:#222222;
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    width:90%;
    text-align: center;
   
    text-justify: auto;
    display: flex;
    align-content: center;
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 5px;
}
   .overlay button{
    color:#fff;
    background-color: #FF3C4E;
    width:131.52px;
    height:42px;
    border-radius:25px;
    text-decoration: underline;
    position: relative;
    overflow: hidden;
    cursor: pointer;
        
    z-index:1
    

}


}








`, "",{"version":3,"sources":["webpack://./src/Styles/HeroSection.css"],"names":[],"mappings":";;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,YAAY;;IAEZ,iBAAiB;;AAErB;;;AAGA;IACI,kBAAkB;QACd,SAAS;QACT,YAAY;;;;;AAKpB;;AAEA;;QAEQ,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,qBAAqB;QACrB,qBAAqB;QACrB,mBAAmB;QACnB,UAAU;QACV,0BAA0B;;;;AAIlC;;;;AAIA;OACO,kBAAkB;QACjB,QAAQ;QACR,SAAS;QACT,2BAA2B;AACnC;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,SAAS;AACb;;;AAGA;IACI,8BAA8B;AAClC;;;AAGA;IACI,6BAA6B;AACjC;;;;AAIA;IACI,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;IAEf;;;AAGJ;;;;;AAKA;AACA,mEAAmE;IAC/D,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,iCAAiC;IACjC,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI;YACQ,UAAU;;YAEV,wBAAwB;;QAE5B;AACR;;;;AAIA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,WAAW;IACX,kBAAkB;;IAElB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;;AAE3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;;IAEnB,kBAAkB;IAClB,qBAAqB;IACrB,QAAM;;AAEV;;AAEA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,aAAa;;YAEb,kBAAkB;;QAEtB;;IAEJ;;YAEQ,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,sBAAsB;YACtB,qBAAqB;YACrB,mBAAmB;YACnB,UAAU;YACV,0BAA0B;;;;IAIlC;QACI;YACI,YAAY;YACZ,WAAW;YACX,aAAa;YACb,mBAAmB;;YAEnB,mBAAmB;YACnB,qBAAqB;YACrB,SAAO;;QAEX;IACJ;YACQ,kBAAkB;YAClB,QAAQ;YACR,QAAQ;YACR,2BAA2B;YAC3B,UAAU;;QAEd;;GAEL;YACS,kBAAkB;YAClB,QAAQ;YACR,SAAS;YACT,SAAS;;QAEb;IACJ;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;IACI,aAAa;IACb,iCAAiC;IACjC,eAAe;IACf,SAAS;IACT,kBAAkB;;IAElB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;GACG;IACC,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;IAEf;;;AAGJ;;;AAGA","sourcesContent":["\n\n.hero-content{\n    display:bloc;\n    flex-direction: column;\n    width:100vw;\n    height:100vh;\n    \n    position:relative;\n\n}\n\n\n.hero-content svg{\n    position: relative;\n        left: 1px;\n        bottom:120px;\n    \n   \n   \n    \n}\n\n.overlay{\n       \n        text-align: center;\n        display:flex;\n        justify-content: center;\n        flex-direction:column;\n        justify-items: center;\n        align-items: center;\n        opacity: 0;\n        transform: translateX(60%);\n       \n           \n\n}\n\n\n\n.overlay.left{\n       position: absolute;\n        top: 40%;\n        left: 10%;\n        transform: translateX(-60%);\n}\n\n.overlay.right{\n    position:absolute;\n    top:40%;\n    right:15%;\n}\n\n\n.overlay.animate.right{\n    animation: slideIn 1s forwards;\n}\n\n\n.overlay.animate.left{\n    animation:slideIn 1s forwards;\n}\n\n\n\n.overlay button{\n    color:#fff;\n    background-color: #FF3C4E;\n    width:131.52px;\n    height:42px;\n    border-radius:25px;\n    text-decoration: underline;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n        \n    z-index:1\n    \n\n}\n\n\n\n\n.overlay button::after{\n/* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #F2C713;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n    \n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n.overlay button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n.overlay .header{\n    color:#FF3C4E;\n    font-family: 'EB Garamond', serif;\n    font-size: 36px;\n    font-weight: 900;\n    \n}\n\n@keyframes slideIn{\n    to {\n            opacity: 1;\n           \n            transform: translateX(0);\n            \n        }\n}\n\n\n\n.overlay .description{\n    color:#222222;\n    font-family: 'Nunito',sans-serif;\n    font-size: 18px;\n    width:500px;\n    text-align: center;\n   \n    text-justify: auto;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    \n}\n.content{\n    width:100vw;\n    height:100vh;\n    display:flex;\n    flex-direction: row;\n   \n    align-items:center;\n    /* margin-top:80px; */\n    flex:1;\n    \n}\n\n@media screen and (max-width:768px){\n    .hero-content {\n            display: bloc;\n            flex-direction: column;\n            width: 100vw;\n            height: 100vh;\n    \n            position: relative;\n    \n        }\n\n    .overlay {\n    \n            text-align: center;\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            justify-items: center;\n            align-items: center;\n            opacity: 0;\n            transform: translateX(60%);\n    \n    \n    \n    }\n        .content {\n            width: 100vw;\n            height: 80%;\n            display: flex;\n            flex-direction: row;\n    \n            align-items: center;\n            /* margin-top:80px; */\n            flex: 1;\n    \n        }\n    .overlay.left {\n            position: absolute;\n            top: 65%;\n            left:0px;\n            transform: translateX(-60%);\n            width: 90%;\n            \n        }\n    \n   .overlay.right {\n            position: absolute;\n            top: 65%;\n            right:0px;\n            width:90%;\n            \n        }\n    .overlay .header{\n        font-size:15px;\n        margin-bottom: 5px;\n    }\n.overlay .description{\n    color:#222222;\n    font-family: 'Poppins',sans-serif;\n    font-size: 14px;\n    width:90%;\n    text-align: center;\n   \n    text-justify: auto;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n   .overlay button{\n    color:#fff;\n    background-color: #FF3C4E;\n    width:131.52px;\n    height:42px;\n    border-radius:25px;\n    text-decoration: underline;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n        \n    z-index:1\n    \n\n}\n\n\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
